'use client';

import * as React from 'react';

/**
 * Subscribe to a CSS media query. Used for the responsive *strategy* switches
 * in the guide (§3) — e.g. radial reactions vs. bottom-sheet, hover gating —
 * which key off capability, not a raw pixel width.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** True only where real hover + a fine pointer exist (desktop, not a 1024px iPad). */
export function useHasHover(): boolean {
  return useMediaQuery('(hover: hover) and (pointer: fine)');
}
